var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubscriberPlanPro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 75,
    viewBox: "0 0 120 75",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12927_137026)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 75,
    rx: 8.12526,
    fill: "url(#paint0_linear_12927_137026)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_12927_137026)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 75,
    rx: 10.3597,
    fill: "white",
    fillOpacity: 0.03
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107.989 75.0004H8.00098C3.5827 75.0004 0.000976562 71.4187 0.000976562 67.0004V9.70508C1.03262 20.2234 17.7435 25.5764 46.5428 30.6949C99.0132 40.0204 112.209 58.7525 107.989 75.0004ZM0.184037 6.29091C0.124142 6.6032 0.0758137 6.91141 0.0389817 7.21562C0.0695454 6.90172 0.118251 6.59312 0.184037 6.29091Z",
    fill: "white",
    fillOpacity: 0.08
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_12927_137026",
    x: -32.5011,
    y: -32.5011,
    width: 185.002,
    height: 140.002,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 16.2505
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_12927_137026"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_12927_137026",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12927_137026",
    x1: -17.194,
    y1: -8.10811,
    x2: 144.483,
    y2: 66.8076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.155325,
    stopColor: "#3431C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91738,
    stopColor: "#CD2525"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12927_137026"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 75,
    rx: 8,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscriberPlanPro);
export default __webpack_public_path__ + "static/media/subscriber-plan-pro.f8176ac7e7f7bffb0c468d4b381a5c34.svg";
export { ForwardRef as ReactComponent };